import { useState, useEffect } from 'react'
import { isEnableRudderStack } from 'lib/rudder'

function useAnonymousId() {
  const [anonymousId, setAnonymousId] = useState(null)
  const [anonymousIdQueryString, setAnonymousIdQueryString] = useState('')

  useEffect(() => {
    const fetchAnonymousId = async () => {
      const isEnableRudder = await isEnableRudderStack()

      if (typeof window === 'undefined') return

      if (isEnableRudder && window.rudderanalytics?.getAnonymousId) {
        const rudderId = window.rudderanalytics.getAnonymousId()
        setAnonymousId(rudderId)
        setAnonymousIdQueryString(`?anon_id=${rudderId}`)
      }
    }

    fetchAnonymousId()
  }, [])

  return { anonymousId, anonymousIdQueryString }
}

export default useAnonymousId
